module.exports = __webpack_public_path__ + "img/bihua.7cf0672a.png";